<template>
  <div>
    <p>
      <player-link :playerId="playerId" label="игрок"/>
      (<router-link :to="{name: 'player_rushes', params: {playerId: playerId}}">ражи</router-link>)
    </p>
    <p>
      <rush-player-link :rushPlayerId="rushPlayerId">
        участник ража
      </rush-player-link>
    </p>
  </div>
</template>

<script>
import PlayerLink from './PlayerLink.vue';
import RushPlayerLink from './RushPlayerLink.vue';

export default {
  name: 'RushRacePlayerInfo',

  components: {
    PlayerLink,
    RushPlayerLink,
  },

  props: {
    rushRaceId: {
      type: Object,
      required: true
    },

    playerId: {
      type: Number,
      required: true,
    },
  },

  computed: {
    rushPlayerId() {
      return {
        rushId:   this.rushRaceId.rushId,
        playerId: this.playerId,
      };
    },
  },
};
</script>
